<template>
  <div id="content-register">
    <v-container grid-list-xl>
      <v-layout align-center justify-center row wrap>
        <v-flex text-xs-center xs12>
          <div class="display-1 head-page">ลงทะเบียน</div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'content-register',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
